import React from 'react';
import Panel from "../../common/portal/Panel";
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getList, update, create, deleteOne } from '../../common/v4/BackendProvider';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DynamicGrid from '../../common/DynamicGrid';
import UploadModal from '../../common/UploadModal'


const Upload = ({ modalIsOpen, onHide, onUploadSuccess }) => {
    return (
        <UploadModal
            modalIsOpen={modalIsOpen}
            onHide={onHide}
            onUploadSuccess={onUploadSuccess}
            modalTitle="Upload New Contact List"
            url_upload="/admin/contacts/upload"
            url_confirm="/admin/contacts/confirm"
        />
    );
};

const ListEdit = (props) => {
    const navigate = useNavigate();
    const { list_id } = useParams();


    const [listData, setListData] = useState({});
    const [loading, setLoading] = useState(true);
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    useEffect(() => {
        getList(`/admin/contacts`)
            .then(response => {
                setListData(response.data.listdata);
                setColumns(response.data.columns);
                setData(response.data.data);
                setLoading(false);
            }).catch(error => {
                toast.error(error.message);
            });
    }, []);

    const handleDataChange = (newData) => {
        setData(newData);
    }
    const handleColumnAdd = (newColumn) => {
        setColumns([...columns, newColumn]);
        create(`/admin/contacts/column/`, {data: newColumn})
            .then(response => {
                toast.success('Column added successfully');
            })
            .catch(error => {
                toast.error('Failed to add column: ' + error.message);
            });
    }
    const handleColumnEdit = (columnName, updatedColumn) => {
        setColumns(columns.map(column => column.name === columnName ? updatedColumn : column));
        update(`/admin/contacts/column/`, columnName, {data: updatedColumn})
            .then(response => {
                toast.success('Column updated successfully');
            })
            .catch(error => {
                toast.error('Failed to update column: ' + error.message);
            });
    }

    const handleCellUpdate = (rowIndex, columnName, newValue) => {
        console.log('PARENT handleCellUpdate:', { rowIndex, columnName, newValue, type: typeof newValue });
        update(`/admin/contacts/cell/${rowIndex}/`, columnName,  { data: { newValue } })
            .then(response => {
                toast.success('Cell updated successfully');
                // Refresh the data to reflect the changes
                return getList(`/admin/contacts`);
            })
            .then(response => {
                setData(response.data.data);
            })
            .catch(error => {
                toast.error('Failed to update cell: ' + error.message);
            });
    }

    const handleDeleteSelectedRows = (rowIds) => {
        // rowIds are now actual database row IDs, not display indices
        
        // Remove rows from data array based on row IDs
        const newData = data.filter(row => !rowIds.includes(row.id));
        setData(newData);
        
        // Make API call to delete rows from the backend
        const deletePromises = rowIds.map(rowId => {
            return deleteOne(`/admin/contacts/row`, rowId)
                .then(response => {
                    toast.success(`Row ${rowId} deleted successfully`);
                })
                .catch(error => {
                    toast.error(`Failed to delete row ${rowId}: ${error.message}`);
                });
        });
        
        Promise.all(deletePromises)
            .then(() => {
                toast.success(`${rowIds.length} row(s) deleted successfully`);
            })
            .catch(error => {
                toast.error('Some rows failed to delete');
            });
    }

    const handleAddRow = () => {
        // Create a new empty row with all columns
        const newRow = {
            id: Date.now(), // Temporary ID for frontend
        };
        
        // Add empty values for all columns
        columns.forEach(col => {
            newRow[col.name] = '';
        });
        
        // Add to local state
        setData([...data, newRow]);
    }

    const onUploadRequest = () => {
        setModalIsOpen(true);
    };

    const onHide = () => {
        setModalIsOpen(false);
    };

    const onUploadSuccess = (resp) => {
        setModalIsOpen(false);
        toast.success('Upload Success: ' + resp.msg);
    };

    return (
        <Panel title="Contacts" options={
                    <button
                        className="btn btn-outline-info"
                        onClick={onUploadRequest}>
                        <i className="material-icons">upload</i>Upload New Contact List
                    </button>
                }>
            <div>
            {modalIsOpen && (
                <Upload 
                    modalIsOpen={modalIsOpen}
                    onHide={onHide}
                    onUploadSuccess={onUploadSuccess}
                />
            )}
            <DynamicGrid
                data={data}
                columns={columns}
                onDataChange={handleDataChange}
                onColumnAdd={handleColumnAdd}
                onColumnEdit={handleColumnEdit}
                onCellUpdate={handleCellUpdate}
                onRowDelete={handleDeleteSelectedRows}
                onRowAdd={handleAddRow}
                rowIdField="id"
                editable={true}
                maxHeight="500px"
                maxWidth="100%"
            />
            </div>
        </Panel>
    )
}
 
export default ListEdit;

